<template>
  <div
    class="splash splash-bg"
    :style="{ backgroundImage: `url(${back1}),url(${back2})` }"
  >
    <div
      class="fl-sym-w-4/5 fl-sym-flex fl-sym-flex-col fl-sym-justiy-center fl-sym-text-center fl-sym-text-white fl-sym-mx-auto"
    >
      <img
        src="@/assets/logo.svg"
        width="146"
        class="fl-sym-mt-64 felcana-logo fl-sym-mx-auto fl-sym-mb-5"
      />
      <div class="fl-sym-text-4xl fl-sym-mb-5 fl-sym-font-light">
        Pet Symptom Checker
      </div>
      <button
        @click="loadSymptomChecker"
        class="fl-sym-text-sm fl-sym-rounded-full fl-sym-px-3 fl-sym-py-2 fl-sym-bg-white fl-sym-text-primary fl-sym-mb-3 focus:fl-sym-bg-gray-300 fl-sym-transition fl-sym-ease-out fl-sym-duration-300 fl-sym-tracking-wide fl-sym-font-semibold"
      >
        <span>Start symptom checker</span>
        <div class="fl-sym-float-right">
          <img
            class="chevron-right"
            src="../assets/chevron-right-thin.svg"
            width="8"
          />
        </div>
      </button>
      <button
        @click="register"
        class="fl-sym-text-sm fl-sym-rounded-full fl-sym-px-3 fl-sym-py-2 fl-sym-bg-white fl-sym-text-primary fl-sym-mb-3 focus:fl-sym-bg-gray-300 fl-sym-transition fl-sym-ease-out fl-sym-duration-300 fl-sym-tracking-wide fl-sym-font-semibold"
      >
        <span>Create account</span>
        <div class="fl-sym-float-right">
          <img
            class="chevron-right"
            src="../assets/chevron-right-thin.svg"
            width="8"
          />
        </div>
      </button>
      <button
        class="fl-sym-text-sm fl-sym-letter-space-1 fl-sym-text-white fl-sym-mb-5 fl-sym-inline-block fl-sym-w-40 fl-sym-mx-auto hover:fl-sym-text-opacity-75"
        @click="login"
      >
        Log in
      </button>

      <div class="fl-sym-text-sm fl-sym-font-family-light fl-sym-mt-0 xs:fl-sym-mt-24">
        <div>By using the Symptom Checker you agree to Felcana's</div>
        <a class="fl-sym-inline fl-sym-underline" href="#">Terms of Service</a>
        <span> & </span>
        <a class="fl-sym-inline fl-sym-underline" href="#">Privacy Policy</a>
      </div>
    </div>
  </div>
</template>
<script>
import back1 from "@/assets/back1.png"
import back2 from "@/assets/back2.png"
export default {
  methods: {
    login() {
      this.$router.push({ name: process.env.VUE_APP_AUTH_LOGIN })
    },
    async loadSymptomChecker() {
      await this.$store.dispatch("sc/begin")
      await this.$router.push({name: process.env.VUE_APP_SYMPTOM_CHECKER_BEGIN});
    },
    register() {
      this.$router.push({ name: process.env.VUE_APP_AUTH_REGISTER_STEP_1 })
    },
  },
  data() {
    return {
      back1,
      back2,
    }
  },
}
</script>

<style lang="postcss">
.splash-bg {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
h1 {
  font-family: "SF Pro Display Light" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.felcana-logo {
  margin-top: 50vh;
}

svg {
  margin-left: 5px;
}
font-awesome-icon:hover {
  color: rgba(83, 213, 230, 0);
}
button span:hover {
  opacity: 0.75;
}
.chevron-right {
  display: inline-block;
}
</style>
